<div class="main-container">

  <div class="title">
    <span class="title-text">Manual Provision</span>
    <p class="small-title">Create a walk-in requisition and provision rooms manually.</p>
  </div>

  <form [formGroup]="req">

    <!-- REQUISITION -->
    <div class="section-title">Requisition</div>
    <div class="grid">
      <div class="field">
        <span class="field-label">From date</span>
        <input type="date" class="text-box-active" formControlName="requisitionFromDate" />
      </div>
      <div class="field">
        <span class="field-label">To date</span>
        <input type="date" class="text-box-active" formControlName="requisitionToDate" />
      </div>
      <div class="field">
        <span class="field-label">Category</span>
        <mat-form-field appearance="outline">
          <mat-select formControlName="requisitionCategory">
            @for(c of categories; track c){ <mat-option [value]="c">{{ c }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Type</span>
        <mat-form-field appearance="outline">
          <mat-select formControlName="requisitionType">
            @for(t of types; track t){ <mat-option [value]="t">{{ t }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Guest count</span>
        <input type="number" class="text-box-active" formControlName="requisitionGuestCount" />
      </div>
      <div class="field">
        <span class="field-label">Male / Female / Child</span>
        <div class="triple">
          <input type="number" class="text-box-active" formControlName="requisitionMaleCount" placeholder="M" />
          <input type="number" class="text-box-active" formControlName="requisitionFemaleCount" placeholder="F" />
          <input type="number" class="text-box-active" formControlName="requisitionChildCount" placeholder="C" />
        </div>
      </div>
      <div class="field">
        <span class="field-label">Family code</span>
        <input type="text" class="text-box-active" formControlName="familyCode" />
      </div>
      <div class="field">
        <span class="field-label">Referred by</span>
        <input type="text" class="text-box-active" formControlName="referredBy" />
      </div>
      <div class="field">
        <span class="field-label">Utsav code</span>
        <input type="text" class="text-box-active" formControlName="utsavCode" />
      </div>
      <div class="field">
        <span class="field-label">Utsav year</span>
        <input type="text" class="text-box-active" formControlName="utsavYear" />
      </div>
      <div class="field">
        <span class="field-label">Purpose category</span>
        <input type="text" class="text-box-active" formControlName="requisitionPurposeCategory" />
      </div>
      <div class="field">
        <span class="field-label">Attached mandir</span>
        <input type="text" class="text-box-active" formControlName="attachedMandir" />
      </div>
      <label class="checkbox-row">
        <input type="checkbox" formControlName="isWorkerIncluded" />
        <span>Worker included</span>
      </label>
    </div>

    <!-- VISITORS -->
    <div class="section-head">
      <div class="section-title">Visitors</div>
      <button type="button" class="ac-secondary-small-btn" (click)="addVisitor()">Add visitor</button>
    </div>
    <div formArrayName="visitors" class="rows">
      @for(vis of visitors.controls; track vis; let i = $index){
      <div class="row-card" [formGroupName]="i">
        <div class="grid">
          <div class="field"><span class="field-label">First name</span><input class="text-box-active" formControlName="visitorFirstName" /></div>
          <div class="field"><span class="field-label">Last name</span><input class="text-box-active" formControlName="visitorLastName" /></div>
          <div class="field">
            <span class="field-label">Gender</span>
            <mat-form-field appearance="outline">
              <mat-select formControlName="visitorGender">
                @for(g of genders; track g){ <mat-option [value]="g">{{ g }}</mat-option> }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="field"><span class="field-label">Mobile</span><input class="text-box-active" formControlName="visitorMobile" /></div>
          <div class="field"><span class="field-label">Family code</span><input class="text-box-active" formControlName="visitorFamilyCode" /></div>
          <div class="field"><span class="field-label">Age (dd-mm-yyyy)</span><input class="text-box-active" formControlName="visitorAge" /></div>
          <div class="field"><span class="field-label">ID type</span><input class="text-box-active" formControlName="visitorIdentityType" /></div>
          <div class="field"><span class="field-label">ID number</span><input class="text-box-active" formControlName="visitorIdentityRefNum" /></div>
          <div class="field"><span class="field-label">Relationship</span><input class="text-box-active" formControlName="visitorRelationship" /></div>
          <div class="field"><span class="field-label">City</span><input class="text-box-active" formControlName="visitorCity" /></div>
          <div class="field"><span class="field-label">State</span><input class="text-box-active" formControlName="visitorState" /></div>
          <label class="checkbox-row"><input type="checkbox" formControlName="isPrimaryVisitor" /><span>Primary</span></label>
        </div>
        <button type="button" class="ac-secondary-small-btn" (click)="removeVisitor(i)">Remove visitor</button>
      </div>
      }
    </div>

    <!-- TRANSPORTATION -->
    <div class="section-head">
      <div class="section-title">Transportation</div>
      <button type="button" class="ac-secondary-small-btn" (click)="addTransport()">Add transport</button>
    </div>
    <div formArrayName="transportation" class="rows">
      @for(t of transportation.controls; track t; let i = $index){
      <div class="row-card" [formGroupName]="i">
        <div class="grid">
          <div class="field"><span class="field-label">Mode</span><input class="text-box-active" formControlName="modeOfTransportation" /></div>
          <div class="field"><span class="field-label">Ticket / PNR</span><input class="text-box-active" formControlName="ticketOrPNRDetail" /></div>
          <div class="field"><span class="field-label">Vehicle number</span><input class="text-box-active" formControlName="vehicleNumber" /></div>
          <div class="field"><span class="field-label">Driver name</span><input class="text-box-active" formControlName="driverFullName" /></div>
          <div class="field"><span class="field-label">Driver licence</span><input class="text-box-active" formControlName="driverLicenseNumber" /></div>
          <label class="checkbox-row"><input type="checkbox" formControlName="driverRequireAccomodation" /><span>Driver needs accommodation</span></label>
        </div>
        <button type="button" class="ac-secondary-small-btn" (click)="removeTransport(i)">Remove transport</button>
      </div>
      }
    </div>

  </form>

  <!-- ROOM SEARCH + SELECTION -->
  <div class="section-title">Rooms</div>
  <div class="room-search">
    <button type="button" class="ac-secondary-btn" (click)="loadPremises()">Find premises (for the above dates)</button>

    @if(premises.length){
    <div class="grid narrow">
      <div class="field">
        <span class="field-label">Premises</span>
        <mat-form-field appearance="outline">
          <mat-select [formControl]="premiseId" (selectionChange)="loadSets()">
            @for(p of premises; track p.premisesId){ <mat-option [value]="p.premisesId">{{ p.premisesName }} ({{ p.totalCapacity }})</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Accommodation set</span>
        <mat-form-field appearance="outline">
          <mat-select [formControl]="accommodationSetId" (selectionChange)="loadRooms()">
            @for(s of sets; track s.accommodationSetId){ <mat-option [value]="s.accommodationSetId">{{ s.accommodationSetName }} ({{ s.totalCapacity }})</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    @if(rooms.length){
    <div class="rooms-list">
      @for(r of rooms; track r.roomcatalogueInstanceId){
      <div class="room-item">
        <span>{{ r.accommodationCode }} · {{ r.accommodationType }} · avail {{ r.availableCapacity }}/{{ r.totalCapacity }}</span>
        <button type="button" class="ac-secondary-small-btn" (click)="addRoom(r)">Add</button>
      </div>
      }
    </div>
    }
  </div>

  @if(selectedRooms.length){
  <div class="selected">
    <div class="section-title">Selected rooms</div>
    @for(r of selectedRooms; track r.roomcatalogueInstanceId; let i = $index){
    <div class="room-item">
      <span>{{ r.premiseName }} · {{ r.accommodationCode }} · {{ r.accommodationType }}</span>
      <button type="button" class="ac-secondary-small-btn" (click)="removeRoom(i)">Remove</button>
    </div>
    }
  </div>
  }

  <div class="submit-row">
    <button type="button" class="ac-primary-btn" (click)="submit()">Provision</button>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
